<template>
  <footer v-show="isFooterBarVisible" class="footer-parent">
    <div class="">
      &copy; 2021, <a href="" target="_blank">Amatra Education</a>
    </div>
  </footer>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
// import Level from '@/components/Level'
// import JbLogo from '@/components/JbLogo'

export default {
  name: 'FooterBar',
  components: {
    // Level
    // JbLogo
  },
  setup () {
    const isAsideMobileExpanded = computed(() => store.state.isAsideMobileExpanded)

    const darkMode = computed(() => store.state.darkMode)

    const store = useStore()

    const year = computed(() => new Date().getFullYear())

    const isFooterBarVisible = computed(() => !store.state.isFullScreen)

    return {
      year,
      darkMode,
      store,
      isFooterBarVisible,
      isAsideMobileExpanded
    }
  }
}
</script>
